module.exports = __webpack_public_path__ + "static/media/logo-dark.e3e2adb1.png";